import { InputWidgetButtonAction } from 'enums/InputWidgetButtonAction';
import { SurveyWidget } from 'enums/SurveyWidget';
import { InputWidgetButtonData } from 'interfaces/InputWidgetButtonData';
import { SurveyRequestCommandData } from 'interfaces/MessageData';
import { setInputWidgetElementErrors } from 'state/inputWidget/inputWidget.actions';
import { InputWidgetState } from 'state/inputWidget/inputWidget.reducer';
import { randomUuid } from 'utils/random';

export type TElementData<Value> = {
    value: Value;
    errors?: string[];
} & ReturnType<typeof surveyWidgetToRegular>['elements'][0];

type TPInputWidgetState = Partial<InputWidgetState>;

export const surveyWidgetToRegular = (command: SurveyRequestCommandData): TPInputWidgetState => {
    const { survey } = command;
    const isCompletescreen = survey.type === SurveyWidget.COMPLETESCREEN;
    const header = isCompletescreen ? '' : survey?.title || command?.header;
    const title = isCompletescreen ? '' : survey?.subtitle || command?.title;

    const getButtons = (command: SurveyRequestCommandData): InputWidgetButtonData[] => {
        const { survey, buttons = [] } = command;
        const caption = survey?.button?.caption;

        const btns = caption
            ? [
                  {
                      action: InputWidgetButtonAction.Ok,
                      text: caption,
                      caption: caption,
                  },
                  ...buttons?.filter((btn) => btn?.action !== InputWidgetButtonAction.Ok),
              ]
            : buttons;

        return [
            {
                action: InputWidgetButtonAction.Close,
                text: 'Закрыть',
                caption: 'close',
            },
            ...btns,
        ].filter(Boolean);
    };

    return {
        header,
        title,
        elements: [{ type: survey.type, survey: survey, elementId: randomUuid() }],
        buttons: getButtons(command),
        isSurvey: true,
    };
};

export const pushError = (elementId: string, errors: string[], newError: string) => {
    if (errors.includes(newError) || !newError) return { type: null };
    return setInputWidgetElementErrors(elementId, [...errors, newError]);
};

export const popError = (elementId: string, errors: string[], errorToPop: string) => {
    if (!errorToPop) return { type: null };
    return setInputWidgetElementErrors(elementId, [...errors?.filter((e) => e !== errorToPop)]);
};
